import { Api } from 'utils';

class ServicesService {
	
	static get = async (params?: any) => Api.createResponse('admin/services/get',params);
	static getSelects = async (params?: any) => Api.createResponse('admin/services/selects',params);
	static create = async (params?: any) => Api.createResponse('admin/services/create',params);
	static createSpecialty = async (params?: any) => Api.createResponse('admin/services/create-specialty',params);
	static update = async (params?: any) => Api.createResponse('admin/services/update',params);
	static delete = async (params?: any) => Api.createResponse('admin/services/delete',params);

}

export default ServicesService;